import { Color, FontSize, FontWeight, Spacing } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

import { headerPdfStyles } from '@features/exports/utils/headerPdfStyles'

export const AuditTrailTableStyles = StyleSheet.create({
  sectionWrapper: {
    width: '100%',
    marginTop: Spacing.S24,
  },
  title: {
    ...headerPdfStyles.titleText,
    fontSize: FontSize.TextBodySM,
    paddingHorizontal: Spacing.S4,
    paddingVertical: Spacing.S2,
  },
  section: {
    marginBottom: Spacing.S16,
  },
  sectionTitle: {
    fontSize: '10px',
    color: Color.Grey500,
    padding: Spacing.S4,
  },
  footerRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: Spacing.S8,
    paddingHorizontal: Spacing.S4,
    paddingVertical: Spacing.S4,
  },
  footerText: {
    fontSize: '10px',
    fontWeight: FontWeight.Bold,
    color: Color.Black,
  },
})
